import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const MaskedLine = ({ children, delay, className }) => (
  <span className="block overflow-hidden pb-1">
    <motion.span
      className={`block ${className || ""}`}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Landing = ({ onStart }) => {
  return (
    <div data-testid="landing-screen" className="flex flex-col flex-1">
      <div className="flex justify-center mb-8">
        <motion.img
          data-testid="landing-logo"
          src="/logo.png"
          alt="Gray Roots Society — Head Up, Crown On"
          className="w-40 h-40 sm:w-48 sm:h-48 rounded-full shadow-[0_8px_30px_-4px_rgba(74,52,40,0.15)]"
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>

      <motion.p
        className="text-xs uppercase tracking-[0.2em] font-semibold text-[#B25E3B] mb-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.35 }}
      >
        A quiet space for a big question
      </motion.p>

      <h1
        data-testid="landing-headline"
        className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.12] tracking-tight text-[#2C221E] mb-5"
      >
        <MaskedLine delay={0.45}>What should I do</MaskedLine>
        <MaskedLine delay={0.58}>with my life?</MaskedLine>
        <MaskedLine delay={0.75} className="mt-3 text-[#B25E3B] italic">
          Starting over at 50, 55, or 60.
        </MaskedLine>
      </h1>

      <motion.p
        data-testid="landing-subheading"
        className="text-base sm:text-lg text-[#5A4D46] leading-relaxed mb-10 max-w-md"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 1.0, ease: [0.22, 1, 0.36, 1] }}
      >
        You're not behind, and you're not too late — you're standing at the
        edge of your most intentional chapter yet.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 1.15, ease: [0.22, 1, 0.36, 1] }}
      >
        <motion.button
          data-testid="landing-start-quiz-btn"
          onClick={onStart}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.97 }}
          className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 rounded-full bg-[#B25E3B] hover:bg-[#9C4E2D] text-[#FAF7F2] text-lg font-semibold px-10 py-5 transition-colors duration-200 shadow-[0_8px_30px_-4px_rgba(178,94,59,0.4)]"
        >
          Find your next step
          <ArrowRight className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" />
        </motion.button>
      </motion.div>

      <motion.p
        data-testid="landing-time-note"
        className="text-sm text-[#85746C] mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 1.3 }}
      >
        Four gentle questions. About a minute. No email needed to see your answer.
      </motion.p>
    </div>
  );
};
